import { Label } from '@ui/lib/park/ui/styled/field';
import { Box, HStack, VStack } from 'styled-system/jsx';
import type { ComponentProps, HTMLStyledProps } from 'styled-system/types';

type Props = {
  children: React.ReactNode;
} & ComponentProps<typeof HStack>;

export const InfoCard: React.FC<Props> = (props: Props) => {
  const { children, ...hstackProps } = props;

  return (
    <HStack
      // background="#222222"
      justifyContent="space-between"
      w="full"
      borderRadius="8px"
      fontSize={14}
      fontWeight="normal"
      p={3}
      {...hstackProps}
    >
      {children}
    </HStack>
  );
};
